/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import UserControls from 'flarum/forum/utils/UserControls';
import app from 'flarum/forum/app';
import { slug } from '../../common';
import Button from 'flarum/common/components/Button';
import AssignAchievementLevelModal from './components/AssignAchievementLevelModal';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.user.assign_achievement`;

export default function () {
	extend(UserControls, 'moderationControls', function (items, user) {
		if (!app.forum.attribute(`${slug}.gamification.enabled`)) {
			return;
		}

		if (app.session.user?.attribute('canAssignAchievement')) {
			items.add(
				'assign-achievement',
				<Button
					icon="fas fa-user-tag"
					onclick={() =>
						app.modal.show(AssignAchievementLevelModal, {
							user: user,
						})
					}
				>
					{t(`${prfx}.control_label`)}
				</Button>
			);
		}
	});
}
